import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const dashboardApi = {
  getStats: () => api.get('/api/dashboard/stats/'),
};

export const domainsApi = {
  getAll: () => api.get('/api/domains/'),
  create: (data) => api.post('/api/domains/', data),
  update: (id, data) => api.put(`/api/domains/${id}/`, data),
  delete: (id) => api.delete(`/api/domains/${id}/`),
  getWhois: (id) => api.get(`/api/domains/${id}/whois_info/`),
  getDnsRecords: (id) => api.get(`/api/domains/${id}/dns_records/`),
  checkExpiration: (id) => api.post(`/api/domains/${id}/check_expiration/`),
  exportPdf: () => `${API_URL}/api/domains/export_pdf/`,
  exportExcel: () => `${API_URL}/api/domains/export_excel/`,
};

export const registrarsApi = {
  getAll: () => api.get('/api/registrars/'),
  create: (data) => api.post('/api/registrars/', data),
};

export const dnsProvidersApi = {
  getAll: () => api.get('/api/dns-providers/'),
  create: (data) => api.post('/api/dns-providers/', data),
};

export const ambientesApi = {
  getAll: () => api.get('/api/ambientes/'),
  create: (data) => api.post('/api/ambientes/', data),
};

export const empresasApi = {
  getAll: () => api.get('/api/empresas/'),
  create: (data) => api.post('/api/empresas/', data),
};

export default api;